<template>
	<section class="trading-history">
		<div class="trading-chart" style="margin-left:-16px;">
			<AnalyticChart :mode="mode" />
		</div>
		<div class="trading-filter">
			<p class="trading-filter__title">Trading bot statistics for the period:</p>
			<div class="trading-filter__body">
				<button class="trading-filter__item" :class="{'trading-filter__item--active' : mode === m}" type="button" @click="mode = m" v-for="m in modes" :key="m">
					{{ m }}
				</button>
			</div>
		</div>
		<div class="trading-stats trading-card card">
			<div class="trading-card__row">
				<i class="trading-card__icon trading-card__icon--orange">
					<Icon name="rocket" />
				</i>
				<span class="trading-card__title">Total deals:</span>
				<span class="trading-card__value">{{ statistic.success + statistic.failed }}</span>
			</div>
			<div class="trading-card__row">
				<i class="trading-card__icon trading-card__icon--green">
					<Icon name="check" :size="1.5" />
				</i>
				<span class="trading-card__title">Successful:</span>
				<span class="trading-card__value">{{ statistic.success }}</span>
			</div>
			<div class="trading-card__row">
				<i class="trading-card__icon trading-card__icon--red">
					<Icon name="close" :size="1.5" />
				</i>
				<span class="trading-card__title">Unsuccessful:</span>
				<span class="trading-card__value">{{ statistic.failed }}</span>
			</div>
			<div class="trading-card__row">
				<i class="trading-card__icon trading-card__icon--green">
					<Icon name="long" />
				</i>
				<span class="trading-card__title">Percentage of profit:</span>
				<span class="trading-card__value">{{ (statistic.profit * 100).toFixed(2) }} %</span>
			</div>
		</div>
		<div class="trading-main">
			<p class="trading-main__title">trading:</p>
			<TradingHistoryItem :trade="trade" v-for="trade in trades" :key="trade.id" />
		</div>
	</section>
</template>
<script lang="ts" setup>

import AnalyticChart from "@/components/AnalyticChart/AnalyticChart.vue";
import Icon from "@/components/Icon/Icon.vue";
import "./TradingHistory.scss";
import TradingHistoryItem from "@/components/TradingHistory/TradingItem/TradingHistoryItem.vue";
import {onMounted, ref, watch} from "vue";
import TradeEntity from "@/entities/TradeEntity";
import {useApiStore} from "@/stores/apiStore";

let modes = [
	'24h',
	'3d',
	'7d',
	'1m'
];

let {api} = useApiStore();
let mode = ref<string>(modes[0]);
let trades = ref<TradeEntity[]>([]);
let statistic = ref<{
	success : number,
	failed : number,
	profit : number,
}>({
	success : 0,
	failed : 0,
	profit : 0
});

watch(mode, async () => {

	let response = await api.getTradeStatistic(mode.value);

	statistic.value = response.reduce((result : any, row : any) => {

		if(+row.p < 0){
			result.failed += row.c;
		}else{
			result.success += row.c;
		}

		result.profit += +row.p;

		return result;

	}, {
		profit : 0,
		failed : 0,
		success : 0
	});

}, {immediate: true});

onMounted(async () => {

	let pagination = await api.getTradeHistory(1, 100, {
		field : 'id',
		mode : 'desc'
	});

	trades.value = pagination.items;

});
</script>